import React, { useState, useEffect } from "react";

export function Preloader({ onComplete }) {
  const [phase, setPhase] = useState(0); // 0=enter, 1=text, 2=exit
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const t1 = setTimeout(() => setPhase(1), 300);
    const t2 = setTimeout(() => setPhase(2), 2200);
    const t3 = setTimeout(() => {
      setVisible(false);
      onComplete();
    }, 3000);
    return () => { clearTimeout(t1); clearTimeout(t2); clearTimeout(t3); };
  }, [onComplete]);

  if (!visible) return null;

  return (
    <div
      className="fixed inset-0 z-[9999] flex items-center justify-center preloader-bg"
      style={{
        opacity: phase === 2 ? 0 : 1,
        transition: "opacity 0.8s ease-in-out",
        pointerEvents: phase === 2 ? "none" : "auto",
      }}
    >
      <div className="text-center">
        <p
          className="text-xs tracking-[0.4em] uppercase font-light"
          style={{
            color: "oklch(0.5 0.04 280)",
            opacity: phase >= 1 ? 1 : 0,
            transform: phase >= 1 ? "translateY(0)" : "translateY(15px)",
            transition: "all 0.8s cubic-bezier(0.16, 1, 0.3, 1)",
          }}
        >
          It doesn't shout.
        </p>
        <p
          className="text-xs tracking-[0.4em] uppercase font-light mt-3 italic"
          style={{
            color: "oklch(0.4 0.06 160)",
            opacity: phase >= 1 ? 1 : 0,
            transform: phase >= 1 ? "translateY(0)" : "translateY(15px)",
            transition: "all 0.8s cubic-bezier(0.16, 1, 0.3, 1) 0.4s",
          }}
        >
          It knows.
        </p>

        {/* Subtle line animation */}
        <div className="mt-8 flex justify-center">
          <div
            className="h-px"
            style={{
              background: "linear-gradient(90deg, transparent, oklch(0.7 0.06 280), transparent)",
              width: phase >= 1 ? "120px" : "0px",
              transition: "width 1.2s cubic-bezier(0.16, 1, 0.3, 1) 0.6s",
            }}
          />
        </div>
      </div>
    </div>
  );
}
